<template>
    <v-list
        v-click-outside="onHideSubmenu"
        :class="classList"
        dense
        :shaped="shaped"
        :color="backgroundColour"
        :disabled="disabled"
        expand
    >
        <template v-for="item in items">
            <app-nav-menu-item
                :key="item.id"
                v-test-id="`platform-nav-${_.snakeCase(item.name)}`"
                :item="item"
                :on-hide-submenu="onHideSubmenu"
                @item-click="onItemClick"
            />
        </template>
    </v-list>
</template>

<script>
export default {
    name: 'AppNavMenu',
    components: {
        AppNavMenuItem: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppNavMenuItem'
            )
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        shaped: {
            type: Boolean,
            default: false
        },
        backgroundColour: {
            type: String,
            default: 'background'
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classList() {
            let classList = ['app-nav-menu'];

            if (this.horizontal) {
                classList.push('app-nav-menu--horizontal');
            }

            return classList.join(' ');
        }
    },
    methods: {
        onHideSubmenu(items = null) {
            items = this._.isArray(items) ? items : this.items;

            if (!this.fixed) {
                for (let item of items) {
                    item.active = false;
                    if (item.hasChildren) {
                        this.onHideSubmenu(item.children);
                    }
                }
            }
        },
        onItemClick(item, active) {
            item.active = active;
            this.$emit('item-click', item, active);
        }
    }
};
</script>

<style lang="scss">
.app-nav-menu {
    color: var(--v-primaryText-base);

    // Item
    .v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
        color: var(--v-primaryText-base);
    }

    // Icon
    .v-list-item__icon {
        color: var(--v-primaryText-base);
        .v-icon {
            display: flex;
            width: 100%;
        }
    }
    .v-list-item__action:first-child,
    .v-list-item__icon:first-child {
        margin-right: 1rem;
        width: 4rem;
    }
    &.v-list--dense {
        .v-list-item__action:first-child,
        .v-list-item__icon:first-child {
            margin-right: 0.5rem;
            width: 3rem;
        }
    }

    // Expand Icon
    .v-list-item__icon.v-list-group__header__append-icon {
        display: none;
    }

    // Title
    .v-list-item__title {
        color: var(--v-primaryText-base);
        .v-icon {
            margin-left: 0.2rem;
            margin-right: 0.2rem;
        }
    }
    &.v-list--dense .v-list-item__title {
        font-size: 0.9rem;
    }

    // Active
    .v-list-item--active {
        color: var(--v-primaryText-base);
        .v-list-item__title .v-icon {
            transform: rotate(90deg);
        }
    }

    // Submenu
    .v-list-group__items {
        position: relative;
        .v-list-item__title {
            font-size: 0.8125rem;
        }
    }

    .app-nav-menu__item-group[data-level]:not([data-level='0']) {
        .v-list-item__icon i {
            font-size: 1rem;
        }
    }

    &:not(.app-nav-menu--horizontal) {
        .app-nav-menu__item-group[data-level]:not([data-level='0']) {
            padding-left: 1.5rem;
        }
    }

    &--horizontal {
        display: flex !important;
        flex-direction: row;
        align-items: center;
        height: 100%;
        padding: 0 !important;

        // Group
        .v-list-group {
            position: relative;
        }

        // Item
        .v-list-item:not(.v-list-group__items .v-list-item) {
            position: relative;
            height: 100%;
            min-width: 8rem;
            border-right: 1px solid rgba(0, 0, 0, 0.07);
        }

        // Link
        .v-list-item--link:not(.v-list-group__items .v-list-item--link) {
            position: relative;
            height: 100%;
            display: block;
            flex-direction: column;
            flex: none;
            padding: 1.2rem 1rem;
        }

        // Title
        .v-list-item__title:not(.v-list-group__items .v-list-item__title) {
            text-align: center;
            padding: 0 0.1rem;
        }

        // Icon
        .v-list-item__action:not(.v-list-group__items .v-list-item__icon):first-child,
        .v-list-item__icon:not(.v-list-group__items .v-list-item__icon):first-child {
            display: block;
            width: 100%;
            height: 2rem;
            margin: 0.4rem 0 0.2rem 0;
            text-align: center;
            .v-icon {
                display: block;
                font-size: 1.4rem;
            }
        }

        // Submenu
        .v-list-group__items {
            position: absolute;
            top: 100%;
            left: -1px;
            background: var(--v-background-base);
            border: 1px solid rgba(0, 0, 0, 0.07);
            border-radius: 0 0 4px 4px;
            min-width: 10rem;
            &:before {
                content: none;
            }
        }

        .v-list-group--active > .v-list-group__header > .v-list-item__title:after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            width: 100%;
            height: 1px;
            background: var(--v-background-base);
            z-index: 1;
        }
    }
}
</style>
